import React from 'react'
import { IconProps, IconWrapper } from './IconWrapper'

const renderIcon = (color: string) => (
    <path
        d='M12.8334 14.6668L9.16675 11.0002L12.8334 7.3335'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
    />
)

export const ArrowChevronLeft: React.FC<IconProps> = ({ color, size }) => (
    <IconWrapper viewBox={'0 0 22 22'} {...{ size, color }} renderIcon={renderIcon} />
)
